import React, { Component } from 'react';

import './Loading.css';

class Loading extends Component {
  render() {
    return (<p className="loading">Carregando...</p>);
  }
}

export default Loading;
